import React from 'react';
// eslint-disable-next-line no-restricted-imports -- the one sanctioned use; everything else renders DialogModal
import { Modal, type ModalProps } from 'reactstrap';
import { DialogLiveRegion } from './DialogAnnouncer';

export type DialogModalProps = ModalProps & {
    /** Id of the element naming the dialog. reactstrap puts only `labelledBy` on the dialog element itself. */
    labelledBy: string;
};

/** reactstrap's `Modal` with a dialog-scoped live region; see PanelSite.md "Announcing while a dialog stays open". */
export default class DialogModal extends React.Component<DialogModalProps> {
    render() {
        const { children, ...modalProps } = this.props;
        return (
            <Modal {...modalProps}>
                <DialogLiveRegion>{children}</DialogLiveRegion>
            </Modal>
        );
    }
}
